// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DataCache } from '@shared/commons/DataCache';
import { WatchlistManager } from './WatchlistManager';
import { WatchlistSheetsStorageManager } from './WatchlistSheetsStorageManager';
import { InstrumentDescriptionUtils } from '../../Instruments/InstrumentDescriptionUtils';
import { InstrumentSpecificType } from '../../Instruments/InstrumentSpecificType';
export class WatchlistInstrumentResolver {
    static resolveAvailableInstrument(instrument, preferredWatchlistName) {
        var _a, _b;
        return ((_b = (_a = this.resolveCachedInstrument(instrument)) !== null && _a !== void 0 ? _a : this.resolveFirstAvailableWatchlistInstrument(preferredWatchlistName)) !== null && _b !== void 0 ? _b : DataCache.getDefaultInstrument(false));
    }
    static resolveFallbackBySavedInteriorId(instDescr) {
        if (isNullOrUndefined(instDescr)) {
            return null;
        }
        const tradableId = instDescr.tradableId;
        const tradableIdStr = isValidNumber(tradableId) ? tradableId.toString() : null;
        if (!isValidString(tradableIdStr)) {
            return null;
        }
        const instrument = DataCache.getFirstTradeInstrumentByTradableId(tradableIdStr);
        if (!isNullOrUndefined(instrument)) {
            return instrument;
        }
        if (isNullOrUndefined(instDescr.id)) {
            return null;
        }
        // continuous contract
        if (instDescr.instrSpecificType === InstrumentSpecificType.ContinuousContract) {
            return DataCache.FindTradableContinuousContract(instDescr.id, instDescr.routeId);
        }
        return null;
    }
    static resolveCachedInstrument(instrument) {
        if (isNullOrUndefined(instrument)) {
            return null;
        }
        return DataCache.getInstrumentByName(instrument.GetInteriorID());
    }
    static resolveFirstAvailableWatchlistInstrument(preferredWatchlistName) {
        var _a;
        const watchlistItem = (_a = WatchlistManager.getItemByName(preferredWatchlistName)) !== null && _a !== void 0 ? _a : WatchlistManager.getFirstItem();
        if (isNullOrUndefined(watchlistItem)) {
            return null;
        }
        for (const instrumentDescription of watchlistItem.getAvailableInstrumentDescriptions()) {
            const instrument = DataCache.getInstrumentByName(InstrumentDescriptionUtils.createInteriorId(instrumentDescription));
            if (!isNullOrUndefined(instrument)) {
                return instrument;
            }
        }
        return null;
    }
    static validateInstrumentDescriptions() {
        const items = WatchlistManager.getItems();
        let needUpdate = false;
        items.forEach((item) => {
            const instrDescriptions = item.getInstrumentDescriptions();
            instrDescriptions.forEach((instrDescr) => {
                var _a;
                const id = parseInt((_a = instrDescr.id) !== null && _a !== void 0 ? _a : '', 10);
                if (Number.isInteger(id)) {
                    return;
                }
                const tradableId = instrDescr.tradableId;
                const tradableIdStr = isValidNumber(tradableId) ? tradableId.toString() : null;
                const instrument = DataCache.getInstrumentByTradable_ID_first(tradableIdStr);
                if (isNullOrUndefined(instrument)) {
                    return;
                }
                const newInstrDescr = Object.assign(Object.assign({}, instrDescr), { id: instrument.Id.toString() });
                item.add(newInstrDescr);
                needUpdate = true;
            });
        });
        if (needUpdate) {
            WatchlistSheetsStorageManager.wasChanged();
        }
    }
}
